// @flow
import Duration from './Duration';

export default Duration;